module.exports = __webpack_public_path__ + "img/orange.de39e3f6.png";